import * as z from "zod/v4";
import { ReturnedProductStatus } from "../../../return";
import { makeReportFilterSchema } from "./base-report-filter";
import { ReportFilterType } from "./report-filter-type";

export enum ProductStatusFilterQuery {
  IS_ANY = "isAny",
  IS_NONE = "isNone",
}

const ProductStatusFilterSchema_ = makeReportFilterSchema(
  ReportFilterType.PRODUCT_STATUS,
  ProductStatusFilterQuery,
  z.array(z.enum(ReturnedProductStatus)),
);
export const ProductStatusFilterSchema: z.ZodType<ProductStatusFilter> =
  ProductStatusFilterSchema_;
export interface ProductStatusFilter
  extends z.infer<typeof ProductStatusFilterSchema_> {}
